export default [
  {
    icon: 'nlu',
    title: 'NLU',
    groups: [
      {
        title: 'Pipeline stages',
        children: [
          {
            apptitle: 'entities',
            icon: 'entities',
            uiSref: 'entities',
            title: 'Entities',
          },
          {
            apptitle: 'rules',
            icon: 'context-rules',
            uiSref: 'groups',
            title: 'Context Rules',
          },
          {
            apptitle: 'intents',
            icon: 'intents',
            uiSref: 'intents',
            title: 'Intents',
          },
        ],
      },
      {
        title: 'Resources',
        children: [
          {
            apptitle: 'test-sets',
            icon: 'test-set',
            uiSref: 'test-sets',
            title: 'Test Sets',
          },
          {
            apptitle: 'dictionaries',
            icon: 'dictionaries',
            uiSref: 'dictionaries',
            title: 'Dictionaries',
          },
          {
            apptitle: 'contexts',
            icon: 'contexts',
            uiSref: 'contexts',
            title: 'Contexts',
          },
          {
            apptitle: 'files',
            icon: 'resources',
            uiSref: 'resources',
            title: 'Files',
          },
          {
            apptitle: 'xpacks',
            icon: 'xpacks',
            uiSref: 'xpacks',
            title: 'xPacks',
          },
        ],
      },
    ],
  },
  {
    apptitle: 'flow',
    icon: 'flow-1',
    uiSref: 'flow',
    title: 'Flow',
  },
  {
    apptitle: 'new-flow',
    icon: 'flow-2',
    uiSref: 'new-flow/canvases',
    title: 'New Flow',
  },
];
